module.exports = __webpack_public_path__ + "img/change_request.696d0b45.svg";